import React from "react"
import PropTypes from "prop-types"
import { reduxForm } from "redux-form"
import { compose } from "recompose"
import { connect } from "react-redux"
import { ChevronRight } from "react-feather"
import styled from "styled-components"
import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"
import Text from "../text"
import Box from "../../lib/ui/ui-box"
import { defaultValues } from "./options"
import Button from "../button"
import { getUserLanguage } from "../../utils/analytics"
import * as Normalizers from "../../lib/normalizers"
import LoadingBubble from "../loading-bubble/loading-bubble.component"

const StartOverText = styled(Text)`
  width: 100%;
  font-weight: 300;
  text-decoration: underline;
`
const ThumbUp = styled.img`
  width: 89px;
  height: 90px;
`
const DetailsTitle = styled.p`
  max-width: 144px;
`

const ValueIcon = styled.img`
  width: 40px;
  height: 38px;
`
const AgeIcon = styled.img`
  width: 43px;
  height: 37px;
`
const LocationIcon = styled.img`
  width: 29px;
  height: 39px;
`

const Step = props => {
  return (
    <Box w={[1]} flexDirection="column" onSubmit={props.handleSubmit}>
      {/* Start over row */}
      <Box w={[1]} justify="flex-start" alignItems="center" algn="center">
        {/* Start over text */}
        <a href={props.intl.formatMessage({ id: "routes.calculator" }) + "/1"}>
          {/* Start over text */}
          <StartOverText
            color="black"
            fontSize={[2, 2, 2]}
            fontWeight="400"
            fontFamily="Libre Baskerville"
          >
            &#60; start over
          </StartOverText>
        </a>
      </Box>
      {/* Eligibility row */}
      {!props.loanMaxAmount ? (
        <Box w={[1]} alignItems="center" justify="center">
          <LoadingBubble />
        </Box>
      ) : (
        <React.Fragment>
          <Box
            flexDirection={["column", "column", "row", "row"]}
            w={[1, 1, 1]}
            mt={[3, 4, 5]}
          >
            <Box>
              {/* Thumb Up */}
              <ThumbUp src="/images/renewal/thumb_up.png" alt="Thumb Up Logo" />
              {/* Details */}
              <Box w={[1, 1, "auto", "auto"]} flexDirection="column" ml={[3]}>
                {/* Details Label */}
                <DetailsTitle
                  align="center"
                  fontSize={[2]}
                  fontWeight="400"
                  fontFamily="Libre Baskerville"
                  color="black"
                >
                  <FormattedMessage
                    id="renewal.eligibility.label"
                    defaults="FAQ"
                  />
                </DetailsTitle>
                {/* Details Value */}
                <Text
                  w={[1]}
                  color="actionPrimary"
                  fontSize={[4]}
                  fontWeight="400"
                  fontFamily="Libre Baskerville"
                >
                  {props.loanMaxAmount
                    ? `${Normalizers.normalizeMoney(props.loanMaxAmount)}`
                    : null}
                </Text>
              </Box>
            </Box>
            {/* Buttons */}
            <Box mt={[4, 4, 0, 0]} ml={["auto"]} flexDirection="column">
              {/* Apply Button */}
              <Link
                to={`${props.intl.formatMessage({
                  id: "routes.reverse"
                })}/1`}
              >
                <Button
                  onClick={() =>
                    window.analytics.track("begin process", {
                      category: "reverse mortgage flow",
                      label: "HOW TO APPLY",
                      location: "calculate amount flow",
                      language: getUserLanguage()
                    })
                  }
                  bg="actionPrimary"
                  pl={[1]}
                  pr={[1]}
                  size="fluid"
                  type="hero"
                  justify="space-between"
                >
                  <Text fontWeight="700" color="white" fontSize={[2]}>
                    <FormattedMessage
                      id="renewal.eligibility.primaryButtonText"
                      defaults="HOW TO APPLY"
                    />
                  </Text>
                  <Text color="backgroundDarkBlue">
                    <ChevronRight size={36} color="white" />
                  </Text>
                </Button>
              </Link>
            </Box>
          </Box>
          {/* Credentials */}
          <Box
            mt={[4]}
            pt={[4]}
            justify={["flex-start"]}
            flexDirection={["column", "column", "row", "row"]}
            style={{
              borderTop: "1px solid #D8D8D8"
            }}
          >
            {/* Value Credential */}
            <Box flexDirection="row" mb={[4, 4, 0, 0]} ml={[0, 0, 4, 4]}>
              {/* Icon */}
              <ValueIcon
                src="/images/renewal/credential_value.png"
                alt="Value Icon"
              />
              {/* Credential Details */}
              <Box flexDirection="column">
                {/* Label Detail */}
                <Text
                  align="center"
                  fontWeight="700"
                  fontSize={[1]}
                  fontFamily="Libre Baskerville"
                  color="actionPrimary"
                  ml={[3]}
                >
                  <FormattedMessage
                    id="renewal.eligibility.credentialValueLabel"
                    defaults=""
                  />
                </Text>
                {/* Credential Value */}
                <Text
                  align="center"
                  fontWeight="400"
                  fontSize={[2]}
                  fontFamily="Libre Baskerville"
                  lineHeight={3}
                  color="actionPrimary"
                  ml={[3]}
                >
                  {props.calculatorEstimatedHomeValue
                    ? `${Normalizers.normalizeMoney(
                        props.calculatorEstimatedHomeValue
                      )}`
                    : null}
                </Text>
              </Box>
            </Box>
            {/* Age Credential */}
            <Box flexDirection="row" mb={[4, 4, 0, 0]} ml={[0, 0, 4, 4]}>
              {/* Icon */}
              <AgeIcon
                src="/images/renewal/credential_age.png"
                alt="Age Icon"
              />
              {/* Credential Details */}
              <Box flexDirection="column">
                {/* Label Detail */}
                <Text
                  align="center"
                  fontWeight="700"
                  fontSize={[1]}
                  fontFamily="Libre Baskerville"
                  color="actionPrimary"
                  ml={[3]}
                >
                  <FormattedMessage
                    id="renewal.eligibility.credentialAgeLabel"
                    defaults="613-769-9213"
                  />
                </Text>
                {/* Credential Value */}
                <Text
                  align="center"
                  fontWeight="400"
                  fontSize={[2]}
                  fontFamily="Libre Baskerville"
                  lineHeight={3}
                  color="actionPrimary"
                  ml={[3]}
                >
                  {props.calculatorAgeOfYoungestHomeOwner
                    ? `${props.calculatorAgeOfYoungestHomeOwner}`
                    : null}
                </Text>
              </Box>
            </Box>
            {/* Location Credential */}
            <Box flexDirection="row" mb={[4, 4, 0, 0]} ml={[0, 0, 4, 4]}>
              {/* Icon */}
              <LocationIcon
                src="/images/renewal/credential_location.png"
                alt="Age Icon"
              />
              {/* Credential Details */}
              <Box flexDirection="column">
                {/* Label Detail */}
                <Text
                  align="center"
                  fontWeight="700"
                  fontSize={[1]}
                  fontFamily="Libre Baskerville"
                  color="actionPrimary"
                  ml={[3]}
                >
                  <FormattedMessage
                    id="renewal.eligibility.credentialLocationLabel"
                    defaults=""
                  />
                </Text>
                {/* Credential Value */}
                <Text
                  align="center"
                  fontWeight="400"
                  fontSize={[2]}
                  lineHeight={3}
                  fontFamily="Libre Baskerville"
                  color="actionPrimary"
                  ml={[3]}
                >
                  {props.calculatorTown ? `${props.calculatorTown}` : null}
                </Text>
              </Box>
            </Box>
          </Box>
        </React.Fragment>
      )}
    </Box>
  )
}

Step.propTypes = {
  isFlowInvalid: PropTypes.bool.isRequired
}

export default compose(
  connect(state => ({
    initialValues: defaultValues
  })),
  reduxForm({
    form: "newMortgageWizard",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(Step)



// WEBPACK FOOTER //
// ./src/components/new-mortgage-wizard/step-estimate.component.js